import "./style.css";

export default function TypingIndicator({ typingUsers, conversation, currentUser }) {
  // Filter out current user and get list of typing users
  const typingUsersList = Object.entries(typingUsers || {})
    .filter(([userId, isTyping]) => isTyping && userId !== currentUser.id)
    .map(([userId]) => {
      const user = conversation.participants.find(p => p._id === userId);
      return user ? user.first_name : 'Someone';
    })
    .filter(Boolean);

  if (typingUsersList.length === 0) {
    return null;
  }

  const getTypingText = () => {
    if (typingUsersList.length === 1) {
      return `${typingUsersList[0]} is typing`;
    } else if (typingUsersList.length === 2) {
      return `${typingUsersList[0]} and ${typingUsersList[1]} are typing`;
    } else {
      return `${typingUsersList.length} people are typing`;
    }
  };

  return (
    <div className="typing_indicator">
      <span className="typing_text">{getTypingText()}</span>
      <div className="typing_dots">
        <div className="typing_dot"></div>
        <div className="typing_dot"></div>
        <div className="typing_dot"></div>
      </div>
    </div>
  );
} 